<template>
    <div>
        维修记录
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>